import { EntityListResource } from './entityList.resource';
/**
 * Resource Historii punktów
 *
 * @export
 * @class PointHistoryResource
 * @extends {Resource}
 */
export class PointHistoryResource extends EntityListResource {
    constructor() {
        super(...arguments);
        this.listFields = {
            id: true,
            created: true,
            points: true,
            pointContainer: {
                id: true,
                name: true
            },
            benefit: {
                id: true,
                name: true
            },
            profile: {
                id: true,
                firstName: true,
                lastName: true
            }
        };
        this.listVariables = { filters: 'PointHistoryFilters' };
    }
}
export const pointHistoryResource = new PointHistoryResource('pointHistory');
//# sourceMappingURL=pointHistory.resource.js.map